module.exports = __webpack_public_path__ + "static/media/amanda-gyetvay.0e7b2305.jpeg";